import "core-js/features/object/assign";
import "core-js/features/object/keys";

const merge = (target, source) => {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  for (let key of Object.keys(source)) {
    if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]));
  }
  // Join `target` and modified `source`
  Object.assign(target || {}, source);
  return target;
};

const getDefaultChoices = obj => {
  let output = {};
  Object.keys(obj).forEach(key => {
    output[key] = typeof obj[key] === "object" ? Boolean(obj[key].selected) : obj[key];
  });
  return output;
};

const createElement = obj => {
  /**
   * obj = {
   *  type: "a",
   *  attributes: {
   *    href: "https://google.com",
   *    target: "_blank",
   *    class: "anchor-class"
   *  },
   *  textNode: "Go to Google"
   * }
   */
  let element = document.createElement(obj.type);
  for (let key of Object.keys(obj.attributes)) {
    element.setAttribute(key, obj.attributes[key]);
  }
  if (obj.textNode) {
    let textNode = document.createTextNode(obj.textNode);
    element.appendChild(textNode);
  }
  return element;
};

const insertElementBefore = (insertThis, beforeThis) => {
  beforeThis.parentNode.insertBefore(insertThis, beforeThis);
};

const insertElementAfter = (insertThis, afterThis) => {
  afterThis.parentNode.insertBefore(insertThis, afterThis.nextSibling);
};

const createCBStyles = data => {
  return `
  <style type="text/css">
    #${data.cookieConfig.name} {
      position: fixed;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding: ${data.stagePadding};
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow-y: auto;
      background: rgba(0, 0, 0, 0.5);
      z-index: ${data.zIndex};
    }
    @media print{
      #${data.cookieConfig.name}{
        display: none;
      }
    }
    #${data.cookieConfig.name} .__dialog {
      position: relative;
      display: block;
      flex: none;
      width: 100%;
      max-width: 720px;
      padding: 15px;
      background: #fff;
      font-size: ${data.fontSize};
    }
    #${data.cookieConfig.name} .__dialog > div { margin-bottom: 15px; }
    #${data.cookieConfig.name} .__dialog > div:last-child { margin: 0; }

    #${data.cookieConfig.name} .__dialog .__heading {
      position: relative;
      display: block;
      font-size: 1.3em;
      font-weight: 500;
      border-bottom: 1px solid #ddd;
      padding: 0 15px 12px;
      margin: 0 -15px 15px;
    }
    #${data.cookieConfig.name} .__dialog .__description a:link,
    #${data.cookieConfig.name} .__dialog .__description a:visited,
    #${data.cookieConfig.name} .__dialog .__description a:active {
      color: ${data.colors.accent};
    }

    #${data.cookieConfig.name} .__dialog .__choices_selections {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      margin: 4px -10px 0;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox {
      position: relative;
      display: block;
      margin: 5px 10px;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox {
      position: relative;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      margin: 0;
      padding: 0;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > span {
      padding: 0.5em;
      font-weight: 500;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > input {
      position: relative;
      display: block;
      height: 24px;
      width: 24px;
      margin: 0;
      -webkit-appearance: none;
      -moz-appearance: none;
      -o-appearance: none;
      appearance: none;
      border: 1px solid #666666;
      transition-duration: 0.3s;
      background-color: #fafafa;
      cursor: pointer;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > input:checked {
      border: 1px solid #666666;
      background-color: #fafafa;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > input[disabled]:checked {
      border: 1px solid #999999;
      background-color: #fafafa;
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > input:checked + span::before {
      position: absolute;
      display: inline-block;
      content: "";
      width: 24px;
      height: 24px;
      left: 0;
      top: 0.33em;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(data.colors.accent)}" d="M8.62,16.68,19.55,5.76,21,7.21,8.62,19.58,2.87,13.83l1.45-1.45Z"/></svg>');
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > input[disabled]:checked + span::before {
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="%23CCCCCC" d="M8.62,16.68,19.55,5.76,21,7.21,8.62,19.58,2.87,13.83l1.45-1.45Z"/></svg>');
    }
    #${data.cookieConfig.name} .__dialog .__choices_selections .__choices_selections_checkbox .checkbox > input:active {
      border: 2px solid #34495e;
    }

    #${data.cookieConfig.name} .__dialog details {
      font-size: 1em;
      margin: 1em auto 1.5em;
      width: 100%;
      background: ${data.colors.detailsBG};
      position: relative;
    }
    #${data.cookieConfig.name} .__dialog details summary {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0;
    }
    #${data.cookieConfig.name} .__dialog details summary .summary-title {
      position: relative;
      display: flex;
      user-select: none;
      font-size: 1em;
      font-weight: ${ data.detailsHeadIsBold ? 'bold' : 'normal' };
    }
    #${data.cookieConfig.name} .__dialog details summary .summary-title::before {
      position: relative;
      display: inline-block;
      content: "${data.labels.showDetails}";
    }
    #${data.cookieConfig.name} .__dialog details summary .summary-title::after {
      position: relative;
      display: inline-block;
      content: "";
      width: 24px;
      height: 24px;
      margin-left: 20px;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${encodeURIComponent(data.colors.detailsArrow)}" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>');
    }
    #${data.cookieConfig.name} .__dialog details summary::-webkit-details-marker {
      display: none;
    }
    #${data.cookieConfig.name} .__dialog details[open] summary .summary-title::before {
      position: relative;
      display: inline-block;
      content: "${data.labels.hideDetails}";
    }
    #${data.cookieConfig.name} .__dialog details[open] summary .summary-title::after {
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${encodeURIComponent(data.colors.detailsArrow)}" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>');
    }
    #${data.cookieConfig.name} .__dialog details:hover {
      cursor: pointer;
    }
    #${data.cookieConfig.name} .__dialog details .summary-content {
      cursor: default;
      line-height: 1.5;
    }
    #${data.cookieConfig.name} .__dialog details .summary-content .__details_content_item {
      margin-top: 1em;
    }
    #${data.cookieConfig.name} .__dialog details .summary-content .__details_content_item_label {
      font-weight: 500;
    }

    #${data.cookieConfig.name} .__dialog .__buttons {
      position: relative;
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      margin: 0 -5px !important;
    }
    #${data.cookieConfig.name} .__dialog .__buttons button {
      position: relative;
      display: block;
      flex: 0 0 auto;
      width: auto;
      padding: 16px 20px;
      border: 2px solid ${data.colors.btnDef};
      border-radius: 4px;
      text-transform: uppercase;
      font-size: 1em;
      font-weight: bold;
      -webkit-appearance: none;
      color: ${data.colors.btnDef};
      background: white;
      cursor: pointer;
      margin: 5px;
    }
    #${data.cookieConfig.name} .__dialog .__buttons button:hover,
    #${data.cookieConfig.name} .__dialog .__buttons button:focus {
      color: ${data.colors.accent};
      background: white;
      border: 2px solid ${data.colors.accent};
    }
    #${data.cookieConfig.name} .__dialog .__buttons .__buttons_accept_all {
      border: 2px solid ${data.colors.accent};
      color: ${data.colors.btnFG};
      background: ${data.colors.accent};
    }
    #${data.cookieConfig.name} .__dialog .__buttons .__buttons_accept_all:hover,
    #${data.cookieConfig.name} .__dialog .__buttons .__buttons_accept_all:focus {
      color: ${data.colors.accent};
      background: white;
      border: 2px solid ${data.colors.accent};
    }

    @media (max-width: 480px) {
      #${data.cookieConfig.name} {
        padding: 30px 15px 15px;
      }
      #${data.cookieConfig.name} .__dialog .__buttons button {
        flex: 1 1 100%;
        width: 100%;
      }
    }

  </style>
`;
};

const createCookieBannerHTML = (cbObj, cbData, cbDefaults) => {
  return `
    <div id="${cbObj.cookieConfig.name}" role="dialog">
      ${createCBStyles(cbObj)}
      <div class="__dialog">
        <div class="__heading">${cbObj.heading}</div>
        <div class="__description">${cbObj.description}</div>
        <div class="__choices">
          <p>${cbObj.labels.checkboxes}</p>
          <div class="__choices_selections">
            ${Object.keys(cbDefaults)
              .map(choiceKey => {
                if (cbObj.choices[choiceKey] === false) return "";
                return `
                <div class="__choices_selections_checkbox __choices_selections_checkbox_${choiceKey}">
                  <label class="checkbox">
                    <input type="checkbox" name="${choiceKey}" ${cbObj.choices[choiceKey].unchangeable ? "disabled" : ""} ${cbData.choices[choiceKey] ? "checked" : ""}/>
                    <span>${cbObj.choices[choiceKey].label}</span>
                  </label>
                </div>
              `;
              })
              .join("")}
          </div>
        </div>
        <details>
          <summary><span class="summary-title"></span></summary>
          <div class="summary-content">
            ${Object.keys(cbDefaults)
              .map(choiceKey => {
                if (cbObj.choices[choiceKey] === false) return "";
                return `
                <div class="__details_content_item">
                  <div class="__details_content_item_label"><strong>${cbObj.choices[choiceKey].label}</strong></div>
                  <div class="__details_content_item_description">${cbObj.choices[choiceKey].description}</div>
                </div>
              `;
              })
              .join("")}
          </div>
        </details>
        <div class="__buttons">
          <button class="__buttons_accept_partial">${cbObj.labels.acceptPartial}</button>
          <button class="__buttons_accept_all">${cbObj.labels.acceptAll}</button>
        </div>

      </div>
    </div>
  `;
};

export { merge, createElement, insertElementBefore, insertElementAfter, createCookieBannerHTML, getDefaultChoices };
